module.exports = __webpack_public_path__ + "img/CGRwebapp_logo.431a31fe.png";